import { __ } from "@wordpress/i18n";

export const LANGUAGES = [
    { label: __("(Afan)/Oromoor/Oriya", "antimanual"), value: "om" },
    { label: __("Abkhazian", "antimanual"), value: "ab" },
    { label: __("Afar", "antimanual"), value: "aa" },
    { label: __("Afrikaans", "antimanual"), value: "af" },
    { label: __("Akan", "antimanual"), value: "ak" },
    { label: __("Albanian", "antimanual"), value: "sq" },
    { label: __("Amharic", "antimanual"), value: "am" },
    { label: __("Arabic", "antimanual"), value: "ar" },
    { label: __("Arabic (Algeria)", "antimanual"), value: "ar-dz" },
    { label: __("Arabic (Bahrain)", "antimanual"), value: "ar-bh" },
    { label: __("Arabic (Egypt)", "antimanual"), value: "ar-eg" },
    { label: __("Arabic (Iraq)", "antimanual"), value: "ar-iq" },
    { label: __("Arabic (Jordan)", "antimanual"), value: "ar-jo" },
    { label: __("Arabic (Kuwait)", "antimanual"), value: "ar-kw" },
    { label: __("Arabic (Lebanon)", "antimanual"), value: "ar-lb" },
    { label: __("Arabic (Libya)", "antimanual"), value: "ar-ly" },
    { label: __("Arabic (Morocco)", "antimanual"), value: "ar-ma" },
    { label: __("Arabic (Oman)", "antimanual"), value: "ar-om" },
    { label: __("Arabic (Qatar)", "antimanual"), value: "ar-qa" },
    { label: __("Arabic (Saudi Arabia)", "antimanual"), value: "ar-sa" },
    { label: __("Arabic (Syria)", "antimanual"), value: "ar-sy" },
    { label: __("Arabic (Tunisia)", "antimanual"), value: "ar-tn" },
    { label: __("Arabic (U.A.E.)", "antimanual"), value: "ar-ae" },
    { label: __("Arabic (Yemen)", "antimanual"), value: "ar-ye" },
    { label: __("Aragonese", "antimanual"), value: "an" },
    { label: __("Armenian", "antimanual"), value: "hy" },
    { label: __("Assamese", "antimanual"), value: "as" },
    { label: __("Avaric", "antimanual"), value: "av" },
    { label: __("Avestan", "antimanual"), value: "ae" },
    { label: __("Aymara", "antimanual"), value: "ay" },
    { label: __("Azeri", "antimanual"), value: "az" },
    { label: __("Bambara", "antimanual"), value: "bm" },
    { label: __("Bashkir", "antimanual"), value: "ba" },
    { label: __("Basque", "antimanual"), value: "eu" },
    { label: __("Belarusian", "antimanual"), value: "be" },
    { label: __("Bengali", "antimanual"), value: "bn" },
    { label: __("Bhutani", "antimanual"), value: "dz" },
    { label: __("Bihari", "antimanual"), value: "bh" },
    { label: __("Bislama", "antimanual"), value: "bi" },
    { label: __("Bosnian", "antimanual"), value: "bs" },
    { label: __("Breton", "antimanual"), value: "br" },
    { label: __("Bulgarian", "antimanual"), value: "bg" },
    { label: __("Burmese", "antimanual"), value: "my" },
    { label: __("Cambodian", "antimanual"), value: "km" },
    { label: __("Catalan", "antimanual"), value: "ca" },
    { label: __("Chamorro", "antimanual"), value: "ch" },
    { label: __("Chechen", "antimanual"), value: "ce" },
    { label: __("Chichewa", "antimanual"), value: "ny" },
    { label: __("Chinese", "antimanual"), value: "zh" },
    { label: __("Chinese (China)", "antimanual"), value: "zh-cn" },
    { label: __("Chinese (Hong Kong SAR)", "antimanual"), value: "zh-hk" },
    { label: __("Chinese (Macau SAR)", "antimanual"), value: "zh-mo" },
    { label: __("Chinese (Singapore)", "antimanual"), value: "zh-sg" },
    { label: __("Chinese (Taiwan)", "antimanual"), value: "zh-tw" },
    { label: __("Church Slavonic", "antimanual"), value: "cu" },
    { label: __("Chuvash", "antimanual"), value: "cv" },
    { label: __("Cornish", "antimanual"), value: "kw" },
    { label: __("Corsican", "antimanual"), value: "co" },
    { label: __("Cree", "antimanual"), value: "cr" },
    { label: __("Croatian", "antimanual"), value: "hr" },
    {
        label: __("Croatian (Bosnia and Herzegovina)", "antimanual"),
        value: "hr-ba",
    },
    { label: __("Croatian (Croatia)", "antimanual"), value: "hr-hr" },
    { label: __("Czech", "antimanual"), value: "cs" },
    { label: __("Danish", "antimanual"), value: "da" },
    { label: __("Divehi", "antimanual"), value: "div" },
    { label: __("Divehi", "antimanual"), value: "dv" },
    { label: __("Dutch", "antimanual"), value: "nl" },
    { label: __("Dutch (Belgium)", "antimanual"), value: "nl-be" },
    { label: __("Dutch (Netherlands)", "antimanual"), value: "nl-nl" },
    { label: __("English", "antimanual"), value: "en" },
    { label: __("English", "antimanual"), value: "us" },
    { label: __("English (Australia)", "antimanual"), value: "en-au" },
    { label: __("English (Belize)", "antimanual"), value: "en-bz" },
    { label: __("English (Canada)", "antimanual"), value: "en-ca" },
    { label: __("English (Caribbean)", "antimanual"), value: "en-cb" },
    { label: __("English (Ireland)", "antimanual"), value: "en-ie" },
    { label: __("English (Jamaica)", "antimanual"), value: "en-jm" },
    { label: __("English (New Zealand)", "antimanual"), value: "en-nz" },
    { label: __("English (Philippines)", "antimanual"), value: "en-ph" },
    { label: __("English (South Africa)", "antimanual"), value: "en-za" },
    { label: __("English (Trinidad and Tobago)", "antimanual"), value: "en-tt" },
    { label: __("English (United Kingdom)", "antimanual"), value: "en-gb" },
    { label: __("English (United States)", "antimanual"), value: "en-us" },
    { label: __("English (Zimbabwe)", "antimanual"), value: "en-zw" },
    { label: __("Esperanto", "antimanual"), value: "eo" },
    { label: __("Estonian", "antimanual"), value: "et" },
    { label: __("Ewe", "antimanual"), value: "ee" },
    { label: __("Faroese", "antimanual"), value: "fo" },
    { label: __("Farsi", "antimanual"), value: "fa" },
    { label: __("Fiji", "antimanual"), value: "fj" },
    { label: __("Finnish", "antimanual"), value: "fi" },
    { label: __("French", "antimanual"), value: "fr" },
    { label: __("French (Belgium)", "antimanual"), value: "fr-be" },
    { label: __("French (Canada)", "antimanual"), value: "fr-ca" },
    { label: __("French (France)", "antimanual"), value: "fr-fr" },
    { label: __("French (Luxembourg)", "antimanual"), value: "fr-lu" },
    { label: __("French (Monaco)", "antimanual"), value: "fr-mc" },
    { label: __("French (Switzerland)", "antimanual"), value: "fr-ch" },
    { label: __("Frisian", "antimanual"), value: "fy" },
    { label: __("Fulah", "antimanual"), value: "ff" },
    { label: __("FYRO Macedonian", "antimanual"), value: "mk" },
    { label: __("Gaelic", "antimanual"), value: "gd" },
    { label: __("Galician", "antimanual"), value: "gl" },
    { label: __("Ganda", "antimanual"), value: "lg" },
    { label: __("Georgian", "antimanual"), value: "ka" },
    { label: __("German", "antimanual"), value: "de" },
    { label: __("German (Austria)", "antimanual"), value: "de-at" },
    { label: __("German (Germany)", "antimanual"), value: "de-de" },
    { label: __("German (Liechtenstein)", "antimanual"), value: "de-li" },
    { label: __("German (Luxembourg)", "antimanual"), value: "de-lu" },
    { label: __("German (Switzerland)", "antimanual"), value: "de-ch" },
    { label: __("Greek", "antimanual"), value: "el" },
    { label: __("Greenlandic", "antimanual"), value: "kl" },
    { label: __("Guarani", "antimanual"), value: "gn" },
    { label: __("Gujarati", "antimanual"), value: "gu" },
    { label: __("Haitian", "antimanual"), value: "ht" },
    { label: __("Hausa", "antimanual"), value: "ha" },
    { label: __("Hebrew", "antimanual"), value: "he" },
    { label: __("Hebrew", "antimanual"), value: "iw" },
    { label: __("Herero", "antimanual"), value: "hz" },
    { label: __("Hindi", "antimanual"), value: "hi" },
    { label: __("Hiri Motu", "antimanual"), value: "ho" },
    { label: __("Hungarian", "antimanual"), value: "hu" },
    { label: __("Icelandic", "antimanual"), value: "is" },
    { label: __("Ido", "antimanual"), value: "io" },
    { label: __("Igbo", "antimanual"), value: "ig" },
    { label: __("Indonesian", "antimanual"), value: "id" },
    { label: __("Indonesian", "antimanual"), value: "in" },
    { label: __("Interlingua", "antimanual"), value: "ia" },
    { label: __("Interlingue", "antimanual"), value: "ie" },
    { label: __("Inuktitut", "antimanual"), value: "iu" },
    { label: __("Inupiak", "antimanual"), value: "ik" },
    { label: __("Irish", "antimanual"), value: "ga" },
    { label: __("Italian", "antimanual"), value: "it" },
    { label: __("Italian (Italy)", "antimanual"), value: "it-it" },
    { label: __("Italian (Switzerland)", "antimanual"), value: "it-ch" },
    { label: __("Japanese", "antimanual"), value: "ja" },
    { label: __("Javanese", "antimanual"), value: "jv" },
    { label: __("Javanese", "antimanual"), value: "jw" },
    { label: __("Kannada", "antimanual"), value: "kn" },
    { label: __("Kanuri", "antimanual"), value: "kr" },
    { label: __("Kashmiri", "antimanual"), value: "ks" },
    { label: __("Kazakh", "antimanual"), value: "kk" },
    { label: __("Kikuyu", "antimanual"), value: "ki" },
    { label: __("Kinyarwanda", "antimanual"), value: "rw" },
    { label: __("Kirghiz", "antimanual"), value: "ky" },
    { label: __("Kirundi", "antimanual"), value: "rn" },
    { label: __("Komi", "antimanual"), value: "kv" },
    { label: __("Kongo", "antimanual"), value: "kg" },
    { label: __("Konkani", "antimanual"), value: "kok" },
    { label: __("Korean", "antimanual"), value: "ko" },
    { label: __("Kuanyama", "antimanual"), value: "kj" },
    { label: __("Kurdish", "antimanual"), value: "ku" },
    { label: __("Kyrgyz", "antimanual"), value: "kz" },
    { label: __("Laothian", "antimanual"), value: "lo" },
    { label: __("Latin", "antimanual"), value: "la" },
    { label: __("Latvian", "antimanual"), value: "lv" },
    { label: __("Limburgan", "antimanual"), value: "li" },
    { label: __("Lingala", "antimanual"), value: "ln" },
    { label: __("Lithuanian", "antimanual"), value: "lt" },
    { label: __("Luba-Katanga", "antimanual"), value: "lu" },
    { label: __("Luxembourgish", "antimanual"), value: "lb" },
    { label: __("Malagasy", "antimanual"), value: "mg" },
    { label: __("Malay", "antimanual"), value: "ms" },
    { label: __("Malay (Brunei Darussalam)", "antimanual"), value: "ms-bn" },
    { label: __("Malay (Malaysia)", "antimanual"), value: "ms-my" },
    { label: __("Malayalam", "antimanual"), value: "ml" },
    { label: __("Maltese", "antimanual"), value: "mt" },
    { label: __("Manx", "antimanual"), value: "gv" },
    { label: __("Maori", "antimanual"), value: "mi" },
    { label: __("Marathi", "antimanual"), value: "mr" },
    { label: __("Marshallese", "antimanual"), value: "mh" },
    { label: __("Moldavian", "antimanual"), value: "mo" },
    { label: __("Mongolian", "antimanual"), value: "mn" },
    { label: __("Nauru", "antimanual"), value: "na" },
    { label: __("Navajo", "antimanual"), value: "nv" },
    { label: __("Ndonga", "antimanual"), value: "ng" },
    { label: __("Nepali (India)", "antimanual"), value: "ne" },
    { label: __("North Ndebele", "antimanual"), value: "nd" },
    { label: __("Northern Sotho", "antimanual"), value: "ns" },
    { label: __("Norwegian", "antimanual"), value: "no" },
    { label: __("Norwegian (Bokmal)", "antimanual"), value: "nb" },
    { label: __("Norwegian (Nynorsk)", "antimanual"), value: "nn" },
    { label: __("Occitan", "antimanual"), value: "oc" },
    { label: __("Ojibwa", "antimanual"), value: "oj" },
    { label: __("Oriya", "antimanual"), value: "or" },
    { label: __("Ossetian", "antimanual"), value: "os" },
    { label: __("Pali", "antimanual"), value: "pi" },
    { label: __("Pashto/Pushto", "antimanual"), value: "ps" },
    { label: __("Polish", "antimanual"), value: "pl" },
    { label: __("Portuguese", "antimanual"), value: "pt" },
    { label: __("Portuguese (Brazil)", "antimanual"), value: "pt-br" },
    { label: __("Portuguese (Portugal)", "antimanual"), value: "pt-pt" },
    { label: __("Punjabi", "antimanual"), value: "pa" },
    { label: __("Quechua", "antimanual"), value: "qu" },
    { label: __("Quechua (Bolivia)", "antimanual"), value: "qu-bo" },
    { label: __("Quechua (Ecuador)", "antimanual"), value: "qu-ec" },
    { label: __("Quechua (Peru)", "antimanual"), value: "qu-pe" },
    { label: __("Rhaeto-Romanic", "antimanual"), value: "rm" },
    { label: __("Romanian", "antimanual"), value: "ro" },
    { label: __("Russian", "antimanual"), value: "ru" },
    { label: __("Sami", "antimanual"), value: "se" },
    { label: __("Sami (Finland)", "antimanual"), value: "se-fi" },
    { label: __("Sami (Norway)", "antimanual"), value: "se-no" },
    { label: __("Sami (Sweden)", "antimanual"), value: "se-se" },
    { label: __("Samoan", "antimanual"), value: "sm" },
    { label: __("Sangro", "antimanual"), value: "sg" },
    { label: __("Sanskrit", "antimanual"), value: "sa" },
    { label: __("Sardinian", "antimanual"), value: "sc" },
    { label: __("Serbian", "antimanual"), value: "sr" },
    {
        label: __("Serbian (Bosnia and Herzegovina)", "antimanual"),
        value: "sr-ba",
    },
    {
        label: __("Serbian (Serbia and Montenegro)", "antimanual"),
        value: "sr-sp",
    },
    { label: __("Serbo-Croatian", "antimanual"), value: "sh" },
    { label: __("Sesotho", "antimanual"), value: "st" },
    { label: __("Shona", "antimanual"), value: "sn" },
    { label: __("Sichuan Yi", "antimanual"), value: "ii" },
    { label: __("Sindhi", "antimanual"), value: "sd" },
    { label: __("Singhalese", "antimanual"), value: "si" },
    { label: __("Siswati", "antimanual"), value: "ss" },
    { label: __("Slovak", "antimanual"), value: "sk" },
    { label: __("Slovenian", "antimanual"), value: "ls" },
    { label: __("Slovenian", "antimanual"), value: "sl" },
    { label: __("Somali", "antimanual"), value: "so" },
    { label: __("Sorbian", "antimanual"), value: "sb" },
    { label: __("South Ndebele", "antimanual"), value: "nr" },
    { label: __("Spanish", "antimanual"), value: "es" },
    { label: __("Spanish (Argentina)", "antimanual"), value: "es-ar" },
    { label: __("Spanish (Bolivia)", "antimanual"), value: "es-bo" },
    { label: __("Spanish (Chile)", "antimanual"), value: "es-cl" },
    { label: __("Spanish (Colombia)", "antimanual"), value: "es-co" },
    { label: __("Spanish (Costa Rica)", "antimanual"), value: "es-cr" },
    { label: __("Spanish (Dominican Republic)", "antimanual"), value: "es-do" },
    { label: __("Spanish (Ecuador)", "antimanual"), value: "es-ec" },
    { label: __("Spanish (El Salvador)", "antimanual"), value: "es-sv" },
    { label: __("Spanish (Guatemala)", "antimanual"), value: "es-gt" },
    { label: __("Spanish (Honduras)", "antimanual"), value: "es-hn" },
    { label: __("Spanish (Mexico)", "antimanual"), value: "es-mx" },
    { label: __("Spanish (Nicaragua)", "antimanual"), value: "es-ni" },
    { label: __("Spanish (Panama)", "antimanual"), value: "es-pa" },
    { label: __("Spanish (Paraguay)", "antimanual"), value: "es-py" },
    { label: __("Spanish (Peru)", "antimanual"), value: "es-pe" },
    { label: __("Spanish (Puerto Rico)", "antimanual"), value: "es-pr" },
    { label: __("Spanish (Spain)", "antimanual"), value: "es-es" },
    { label: __("Spanish (United States)", "antimanual"), value: "es-us" },
    { label: __("Spanish (Uruguay)", "antimanual"), value: "es-uy" },
    { label: __("Spanish (Venezuela)", "antimanual"), value: "es-ve" },
    { label: __("Sundanese", "antimanual"), value: "su" },
    { label: __("Sutu", "antimanual"), value: "sx" },
    { label: __("Swahili", "antimanual"), value: "sw" },
    { label: __("Swedish", "antimanual"), value: "sv" },
    { label: __("Swedish (Finland)", "antimanual"), value: "sv-fi" },
    { label: __("Swedish (Sweden)", "antimanual"), value: "sv-se" },
    { label: __("Syriac", "antimanual"), value: "syr" },
    { label: __("Tagalog", "antimanual"), value: "tl" },
    { label: __("Tahitian", "antimanual"), value: "ty" },
    { label: __("Tajik", "antimanual"), value: "tg" },
    { label: __("Tamil", "antimanual"), value: "ta" },
    { label: __("Tatar", "antimanual"), value: "tt" },
    { label: __("Telugu", "antimanual"), value: "te" },
    { label: __("Thai", "antimanual"), value: "th" },
    { label: __("Tibetan", "antimanual"), value: "bo" },
    { label: __("Tigrinya", "antimanual"), value: "ti" },
    { label: __("Tonga", "antimanual"), value: "to" },
    { label: __("Tsonga", "antimanual"), value: "ts" },
    { label: __("Tswana", "antimanual"), value: "tn" },
    { label: __("Turkish", "antimanual"), value: "tr" },
    { label: __("Turkmen", "antimanual"), value: "tk" },
    { label: __("Twi", "antimanual"), value: "tw" },
    { label: __("Uighur", "antimanual"), value: "ug" },
    { label: __("Ukrainian", "antimanual"), value: "uk" },
    { label: __("Urdu", "antimanual"), value: "ur" },
    { label: __("Uzbek", "antimanual"), value: "uz" },
    { label: __("Venda", "antimanual"), value: "ve" },
    { label: __("Vietnamese", "antimanual"), value: "vi" },
    { label: __("Volapuk", "antimanual"), value: "vo" },
    { label: __("Walloon", "antimanual"), value: "wa" },
    { label: __("Welsh", "antimanual"), value: "cy" },
    { label: __("Wolof", "antimanual"), value: "wo" },
    { label: __("Xhosa", "antimanual"), value: "xh" },
    { label: __("Yiddish", "antimanual"), value: "ji" },
    { label: __("Yiddish", "antimanual"), value: "yi" },
    { label: __("Yoruba", "antimanual"), value: "yo" },
    { label: __("Zhuang", "antimanual"), value: "za" },
    { label: __("Zulu", "antimanual"), value: "zu" },
];

export const GPT_LANGUAGES = LANGUAGES.filter((lang) =>
    `am ar bg bn bs ca cs da de el en es et fi fr gu hi hr hu hy id in is it ja ka kk kn ko ls lt lv ml mn mr ms my nl no pa pl pt ro ru sk sl so sq sr sv sw ta te th tl tr uk ur vi zh`
        .split(" ")
        .includes(lang.value)
);

export function getLanguageLabel(lang?: string): string {
    const language = LANGUAGES.find((l) => l.value === lang);
    return language ? language.label : __("N/A", "antimanual");
}
